import { render, staticRenderFns } from "./PostRegistrationMessage.vue?vue&type=template&id=4cb1f160&scoped=true&"
import script from "./PostRegistrationMessage.vue?vue&type=script&lang=js&"
export * from "./PostRegistrationMessage.vue?vue&type=script&lang=js&"
import style0 from "./PostRegistrationMessage.vue?vue&type=style&index=0&id=4cb1f160&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4cb1f160",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VFlex } from 'vuetify/lib/components/VGrid';
import { VLayout } from 'vuetify/lib/components/VGrid';
import { VSpacer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VContainer,VFlex,VLayout,VSpacer})
